import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const restrictLabels = require('../restriction_pm_labels.json');

const useRestrictionTrack = (track, isEnabled) => {
  const [isRestricted, setRestricted] = useState(!isEnabled);
  const isPM = useSelector(state => state.inRoomPM); //enablePM

  useEffect(() => {
    if (isEnabled && isPM) {
      setRestricted(restrictLabels.includes(track.label_id));
    } else {
      setRestricted(false);
    }
  }, [track, isEnabled, isPM])

  return isRestricted;
};

export default useRestrictionTrack;
